<template>
    <div class="notifications-listing-page">
        <section class="section">
            <div v-if="initDone && notificationOrders.length > 0" class="container">
                <div class="columns">
                    <div class="column">
                        <h1 class="title">
                            {{ translate("notification_center.listing.main_title") }}
                        </h1>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <div class="buttons">
                            <a :href="notificationCenter().createNotificationPage()" class="button is-primary">
                                <span class="icon">
                                    <i class="fas fa-plus" />
                                </span>
                                <span>{{ translate("notification_center.main_title") }}</span>
                            </a>
                        </div>
                    </div>
                </div>

                <div class="columns">
                    <div class="column">
                        <NotificationOrdersTable />
                    </div>
                </div>
            </div>
            <div v-if="!initDone" class="container">
                <div class="columns is-centered">
                    <LoadingSpinner2 class="has-added-margin" />
                </div>
            </div>

            <ShowContentModal ref="showContentModal" />
        </section>

        <section v-if="initDone && notificationOrders.length === 0" class="hero is-halfheight">
            <div class="hero-body">
                <div class="container has-text-centered">
                    <div class="mb-5 is-size-3">
                        <span class="icon-text is-large">
                            <i class="fas fa-2x fa-envelope"></i>
                        </span>
                    </div>

                    <h1 class="title">{{ translate("notification_center.listing.manage") }}</h1>

                    <div class="mt-5">
                        <a :href="notificationCenter().createNotificationPage()" class="button is-primary is-medium">
                            <span class="icon">
                                <i class="fas fa-play-circle"></i>
                            </span>
                            <span>
                                {{ translate("notification_center.listing.get_started") }}
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import urlsMixin from "../Urls/urlsMixin";
    import translatorMixin from "../Common/translatorMixin";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import ShowContentModal from "./Listing/ShowContentModal";
    import { eventBus, SHOW_CONTENT_MODAL_OPEN } from "./eventBus";
    import NotificationOrdersTable from "./Listing/NotificationOrdersTable.vue";
    import { mapState } from "vuex";

    export default {
        name: "notification-center-listing-app",
        components: { NotificationOrdersTable, ShowContentModal, LoadingSpinner2 },
        mixins: [urlsMixin, translatorMixin],
        data() {
            return {
                initDone: false,
            };
        },
        computed: {
            ...mapState("main", ["notificationOrders"]),
        },
        mounted() {
            this.initDone = false;
            this.$store.dispatch("main/refreshNotificationOrders").finally(() => {
                this.initDone = true;
            });

            eventBus.$on(SHOW_CONTENT_MODAL_OPEN, content => {
                this.$refs.showContentModal.open(content);
            });
        },
    };
</script>

<style scoped></style>
